import request from '@/utils/request'
const BASE_URL = '/StudentClass'

//学生信息
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  //获取年级班级
  getGradeClasses(termId) {
    return request({
      url: BASE_URL + '/GetGradeClasses',
      method: 'get',
      params: { termId }
    })
  },
  //班级添加学生
  addStudentClass(data) {
    return request({
      url: BASE_URL + '/AddStudentClass',
      method: 'post',
      data
    })
  },
  //调班
  changeClass(data) {
    return request({
      url: BASE_URL + '/ChangeClass',
      method: 'post',
      data
    })
  },
  //设座位
  setSeatNumber(id, seatNumber) {
    return request({
      url: BASE_URL + '/SetSeatNumber',
      method: 'get',
      params: { id, seatNumber }
    })
  },
  //调宿舍
  changeDormitory(data) {
    return request({
      url: BASE_URL + '/ChangeDormitory',
      method: 'post',
      data
    })
  },
  //设宿舍
  setDormitory(params) {
    return request({
      url: BASE_URL + '/SetDormitory',
      method: 'get',
      params,
    })
  },
  setCourse(data) {
    return request({
      url: BASE_URL + '/SetCourse',
      method: 'post',
      data
    })
  },
  import: "/api" + BASE_URL + "/Import",
  dormImport: "/api" + BASE_URL + "/ImportDormitory",
  importCourse: "/api" + BASE_URL + "/ImportCourse",
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  }
}